import React from "react";

const BangladeshHealth = () => {
  return (
    <div
      id="bangladesh"
      className="space-y-4 text-softBlack leading-loose text-base font-normal scroll-mt-24"
    >
      <p className="font-bold text-xl text-black mb-4">Bangladesh</p>

      <ul className="space-y-1 list-disc list-outside ml-6">
        <li>
          According to the{" "}
          <a
            href="https://www.who.int/bangladesh/news/detail/27-11-2019-minister-of-health-releases-first-findings-of-national-mental-health-survey"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue underline"
          >
            Bangladesh National Mental Health Survey
          </a>{" "}
          2019, mental health disorders affected 1 in 5 adults and about 1 in 8
          children aged 7–17 years. Nine out of 10 people affected with mental
          disorders were not receiving any treatment for their condition.
        </li>
        <li>
          The treatment gap in adults is 91 percent and is almost the same in
          urban and rural areas.
        </li>
        <li>
          According to WHO data, there are only{" "}
          <a
            href="https://www.who.int/data/gho/data/indicators/indicator-details/GHO/psychiatrists-working-in-mental-health-sector-(per-100-000)"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue underline"
          >
            0.130 psychiatrists
          </a>{" "}
          and{" "}
          <a
            href="https://www.who.int/data/gho/data/indicators/indicator-details/GHO/psychologists-working-in-mental-health-sector-(per-100-000)"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue underline"
          >
            0.124 psychologists
          </a>{" "}
          per 100,000 population.
        </li>
        <li>
          Bangladesh also faces a severe scarcity of human resources in mental
          healthcare. According to a{" "}
          <a
            href="https://www.cambridge.org/core/journals/bjpsych-international/article/current-state-of-mental-healthcare-in-bangladesh-part-1-an-updated-country-profile/19B7DE453E1ED7B460CC25F29A4897A7"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue underline"
          >
            2021 article
          </a>{" "}
          only 0.49 percent of healthcare workers are trained to provide mental
          health services and most of the available mental healthcare workers
          are in Dhaka. According to the article, Another major challenge when
          it comes to mental healthcare in the country is the widespread social
          stigma associated with it. There are many superstitions surrounding
          the cause of mental health conditions, such as the belief that mental
          health conditions are a result of possession by evil spirits, as
          opposed to biological or psychological mechanisms. These superstitions
          act as a major barrier to accessing treatment for these conditions.
        </li>
        <li>
          According to{" "}
          <a
            href="https://cdn.who.int/media/docs/default-source/searo/bangladesh/publications/mental-health-investment-case-in-bangladesh.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue underline"
          >
            a WHO report
          </a>
          , in 2021, USD 3.4 billion was allocated to the health sector,
          representing 5.4 percent of the total budget for fiscal year 2021,
          with mental health expenditure only accounting for 0.44 percent of the
          total health budget.
        </li>
      </ul>

      <p className="font-bold text-black">
        Mental health policy and mental health act
      </p>

      <div className="space-y-4">
        <p>
          Bangladesh brought in a{" "}
          <a
            href="https://nimh.gov.bd/english/wp-content/uploads/2023/04/Bangladesh-National-Mental-Health-Policy-2022.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue underline"
          >
            National Mental Health Policy
          </a>{" "}
          in 2022. The working group that drafted the policy had also created a{" "}
          <a
            href="https://nimh.gov.bd/wp-content/uploads/2023/04/Bangladesh-National-Mental-Health-Strategic-Plan-2020-2030.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue underline"
          >
            strategic plan for 2020–2030
          </a>
          , with the plan to implement it through five-year action plans. The
          strategic plan focuses on a shift from a medical to a psychosocial
          treatment model, emphasizing decentralization and community-based
          services.
        </p>
        <p>
          <a
            href="https://cdn.who.int/media/docs/default-source/mental-health/special-initiative/who-special-initiative-country-report---bangladesh---2020_f746e0ca-8099-4d00-b126-fa338a06ca6e.pdf?sfvrsn=c2122a0e_7"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue underline font-bold italic"
          >
            The key components of the plan include:
          </a>{" "}
        </p>
        <ul className="space-y-2 list-disc list-outside ml-6">
          <li>
            <b>Primary healthcare integration:</b> Calls for integration of
            mental health services across all tiers of the public healthcare
            system
          </li>
          <li>
            <b>Decentralization:</b> Extending mental health services to
            divisions, then districts, and upazilas (sub-districts and the
            second lowest tier of administration) in both rural and urban areas
          </li>
          <li>
            <b>Equity:</b> Focusing on mental health services that value gender
            equality, a life course approach, providing mental health services
            to at-risk and vulnerable populations
          </li>
        </ul>
        <p className="italic">
          Note: According to the{" "}
          <a
            href="https://www.who.int/europe/publications/i/item/9789289053266"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue underline"
          >
            WHO
          </a>
          , a life course approach “takes a temporal and societal perspective on
          health and individuals and generations, recognizing that all stages of
          a person’s life are intricately intertwined with each other, with the
          lives of others born in the same period, and with the lives of past
          and future generations.” It considers how a person's experiences
          influence health and life decisions.
        </p>
        <ul className="space-y-2 list-disc list-outside ml-6">
          <li>
            <b>Innovative programming:</b> Extending the reach of mental health
            services through e-Health. Mental healthcare providers and field
            officers are to be offered training using distance learning modules
            delivered through tablets.
          </li>
        </ul>
        <p>
          A new Mental Health Act was approved by the government in 2018. The
          new Act replaced the 106-year-old{" "}
          <a
            href="https://academic.oup.com/medlaw/article-abstract/32/1/101/7459209"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue underline italic"
          >
            Lunacy Act
          </a>
          , and outlines provisions for care, welfare, and protection of the
          rights of anyone suffering from a mental health condition.
        </p>
      </div>

      <p className="font-bold text-black">
        WHO’s Special Initiative for Mental Health
      </p>

      <div className="space-y-4">
        <p>
          In 2024, Bangladesh became one of nine countries selected to be part
          of the WHO’s{" "}
          <a
            href="https://www.who.int/initiatives/who-special-initiative-for-mental-health"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue underline"
          >
            Special Initiative for Mental Health
          </a>
          , which supports countries in addressing the treatment gap.
        </p>
        <p>
          The initiative focuses on strengthening mental health systems across
          the country. Some of the key activities include capacity building to
          enable mental health services in primary care and private sector and
          supporting telemedicine as well as other modes that can help
          facilitate the availability of mental health services in primary
          healthcare facilities. A separate Directorate for Mental Health is
          also proposed as part of the operational plan.
        </p>
      </div>
    </div>
  );
};

export default BangladeshHealth;
